import Vue from 'vue';
import sk from 'vee-validate/dist/locale/sk';
import VeeValidate, { Validator } from 'vee-validate';

// Install the Plugin.
Vue.use(VeeValidate);

// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize('sk', sk);